import React from 'react';
import { AlertCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../redux/store';
import { selectDocumentSearchAssistantMessage } from '../../redux/selectors/documentSearchSelectors';
import { getLanguageDirection } from '../../i18n/config';

const DocumentSearchError: React.FC = () => {
  const { t, i18n } = useTranslation();
  const assistantMessage = useAppSelector(selectDocumentSearchAssistantMessage);

  const errorMessage = assistantMessage?.content ||
    t('components.documentSearch.searchError', 'An error occurred during the document search');

  return (
    <div className="max-w-[900px] mx-auto mt-8">
      <div className="rounded-2xl border-2 border-destructive/20 bg-destructive/[0.02] p-8">
        {/* Icon + title */}
        <div className="flex items-center gap-4 mb-6">
          <div className="w-12 h-12 rounded-full bg-destructive/10 flex items-center justify-center shrink-0">
            <AlertCircle size={24} className="text-destructive" />
          </div>
          <h3 className="text-lg font-semibold text-destructive">
            {t('components.documentSearch.searchFailed', 'Document Search Failed')}
          </h3>
        </div>

        {/* Error message */}
        <p
          dir={getLanguageDirection(i18n.language)}
          className="text-foreground text-[0.95rem] leading-relaxed whitespace-pre-wrap"
        >
          {errorMessage}
        </p>

        {/* Help text */}
        <div className="mt-6 pt-6 border-t border-border/40">
          <p className="text-sm text-muted-foreground italic">
            {t('components.documentSearch.errorHelpText',
              'If the problem persists, please try creating a new document search or contact support.'
            )}
          </p>
        </div>
      </div>
    </div>
  );
};

export default DocumentSearchError;
